import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TERRAFORM_VENDOR_CONFIG_TYPENAME } from "shared/Stack/OpenTofuMigration/constants";
import { OpenTofuMigrateStackNode } from "shared/Stack/OpenTofuMigration/gql";

const OpenTofuMigrationReadyToMigrateTableVersionCell = ({
  item: stack,
  ...cellProps
}: TableSimpleCellProps<OpenTofuMigrateStackNode>) => {
  const { vendorConfig } = stack;
  const version =
    vendorConfig?.__typename === TERRAFORM_VENDOR_CONFIG_TYPENAME ? vendorConfig.version : null;

  return (
    <TableSimpleCell {...cellProps}>
      {version && <TableCellText>{version}</TableCellText>}
      {!version && <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default OpenTofuMigrationReadyToMigrateTableVersionCell;
